import { mergeMap, map, filter, take, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { isAuthenticatedSelector } from '@cbridge-packages/auth';
import { queryParamSelector } from '@cbridge-packages/routing';
import { PageContextAction } from '@cbridge-packages/page-context';
import { ClientSymbolFilter } from '@cbridge-packages/symbol-client';
import { SymbolMappingFilterParam } from '../_helpers/symbolMappingFilterSearchParam';
import { SymbolMappingFilterAction } from '../symbolMappingFilter.action';

type IState = IGetSelectorStateType<typeof queryParamSelector> & IGetSelectorStateType<typeof isAuthenticatedSelector>;

export const initSymbolMappingFilterEpic: IEpic<IState> = (action$, state$) => {
  return state$.pipe(
    map((state) => ({
      filterValue: queryParamSelector(state, SymbolMappingFilterParam.name),
      isAuthenticated: isAuthenticatedSelector(state),
    })),
    filter(({ filterValue, isAuthenticated }) => filterValue && isAuthenticated),
    distinctUntilChanged(),
    take(1),
    mergeMap(({ filterValue }) => {
      if (!Object.values(ClientSymbolFilter).includes(filterValue as ClientSymbolFilter)) {
        return [];
      }

      return [SymbolMappingFilterAction.setFilter(filterValue as ClientSymbolFilter)];
    }),
    takeUntil(action$.pipe(isTypeOf(PageContextAction.init.done, PageContextAction.init.failed))),
  );
};
